export default __webpack_public_path__ + "static/get-in-contact-aec173355f99168055d9d1c4cfb7a961.svg";